/**
 *
 * Search Service Selectors
 *
 */

import { createSelector } from 'reselect/lib';
import { NAMESPACE } from './constants';

const selectService = (state) => state ? state[NAMESPACE] : {};

const selectStatus = createSelector(selectService, (service) => service.status);

const selectApexAccountNumber = createSelector(selectService, (service) => service.apexAccountNumber);

const selectResults = createSelector(selectService, (service) => service.results || []);

const selectError = createSelector(selectService, (service) => service.error);

export {
  selectApexAccountNumber,
  selectService,
  selectStatus,
  selectResults,
  selectError,
};



// WEBPACK FOOTER //
// ./src/services/recentDeposits/selectors.js